<template>
	
	<div class="index-bg-left">
		<div class="index-bg-right">
			<div class="main__container">
				<div class="main__header">
					<a href="/" aria-label="Aafiyat Search" title="Aafiyat Search">
						<div class="logo-big"></div>
					</a>
					<nav class="nav nav--index main__nav">
						<ul class="menu">
							<li :class="activeClass('web')"><a class="menu__link" v-on:click="toggleActive('web')" href="javascript:void(0)">Web</a></li>
							<li :class="activeClass('testimonials')"><a class="menu__link" v-on:click="toggleActive('testimonials')" href="javascript:void(0)">Testimonials</a></li>
							<li :class="activeClass('scientific_research')"><a class="menu__link" v-on:click="toggleActive('scientific_research')" href="javascript:void(0)">Scientific Research</a></li>							
							<!-- <li :class="activeClass('islamic')"><a class="menu__link" v-on:click="toggleActive('islamic')" href="javascript:void(0)">Islamic References</a></li> -->
						</ul>
					</nav>
				</div>
				<div class="search search--index main__search">
					<form id="search-top" name="searchform" action="/search" method="get">
						<div class="awesomplete"><input name="q" type="text" maxlength="100" value="" :placeholder="placeHolder" aria-label="Search" autocomplete="off" aria-owns="awesomplete_list_1" role="combobox" style="border-radius: 24px 0 0 24px;"><ul hidden="" role="listbox" id="awesomplete_list_1"></ul><span class="visually-hidden" role="status" aria-live="assertive" aria-atomic="true">Type 2 or more characters for results.</span></div>
						<button class="btn btn--search" type="submit" id="quick-search" aria-label="Search" style="border-radius: 0 24px 24px 0;"><span class="icon icon--search"></span></button>
						<input type="hidden" name="type" v-model="type">
					</form>
				</div>
				<div class="page-learn">Learn about: <a href="/view/453gz9Xeb81okvAweX/qa-bersama-dr-salman-dr-hafizah?q=salman&type=web">Frequently Asked Questions</a></div>
				<div class="page-fyi">
					<span style="white-space:nowrap;"><span class="icon icon-guide" style="top:1px;"></span><a href="/site/about" style="font-weight:bold;">About</a></span>
					&nbsp; &nbsp;<span style="white-space:nowrap;"><span class="icon-books"></span><a href="/directory"><strong>Directory</strong></a></span>
					<!-- &nbsp; &nbsp;<span style="white-space:nowrap;"><span class="icon icon-dict" style="top:1px;"></span><a href="/dictionary" style="font-weight:bold;">Dictionary</a></span>					 -->
					<!-- &nbsp; &nbsp;<span style="white-space:nowrap;"><span class="icon icon-guide" style="top:1px;"></span><a href="/directory/testimoni-dan-pengalaman-pengguna/BLPvQA6add9O_W65n3" style="font-weight:bold;">Testimonials</a></span>					 -->
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				searchType: "web",
				type: "web",
				placeHolder: "Search",
			};
		},
		mounted() {
		},
		methods: {
			activeClass(segment) {
				return segment == this.searchType ? 'menu__item is-active' : 'menu__item'
			},
			toggleActive (index) {
				this.searchType = index;
				this.type = index;
				if (index == 'web') {
					this.placeHolder = "Search";
				}
				if (index == 'testimonials') {
					this.placeHolder = "Search Testimonials";
				}
				if (index == 'scientific_research') {
					this.placeHolder = "Search Scientific Research";
				}
				if (index == 'islamic') {
					this.placeHolder = "Search Islamic References";
				}
			},      	
		},
		computed: {
		},   
	}
</script>

